import { render, staticRenderFns } from "./PostPackagesView.vue?vue&type=template&id=18ffa3c6&scoped=true"
import script from "./PostPackagesView.vue?vue&type=script&lang=js"
export * from "./PostPackagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ffa3c6",
  null
  
)

export default component.exports